export default "__VITE_ASSET__BdMrZAg4__"